export const onClick = ({
  hotspotType,
  drawing,
  startXY,
  root,
  inverseScale,
  rectState,
  pubSub,
}) => {
  return e => {
    if (hotspotType === 'rectangle') {
      return;
    }

    e.persist();

    pubSub.publish('UPDATE_HOTSPOT_POINTS', {
      points: [
        (e.clientX - root.current!.getBoundingClientRect().left) * inverseScale,
        (e.clientY - root.current!.getBoundingClientRect().top) * inverseScale,
      ],
    });
  };
};
